import { render } from "./toast.vue?vue&type=template&id=400ecfa0"
const script = {}

import "./toast.vue?vue&type=style&index=0&id=400ecfa0&lang=less"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__